import React from "react";
import FloatingButton from "../FloatingButton/FloatingButton";
import { Toaster } from "react-hot-toast";
import { InfiniteScroll } from "../../nq-component";

export default function PageContainer({
  children,
  title,
  buttonHandler,
  rightButtonLabel,
  rightButtonHandler,
  navigateBack,
  infiniteScroll,
}) {
  return (
    <div
      className="p-5 d-flex flex-column gap-4 overflow-auto"
      style={{ height: "100vh" }}
    >
      <Toaster />
      <div className="d-flex w-100 justify-content-between align-items-center">
        {title && (
          <h2 className="fw-bold text-primary">
            {navigateBack ? (
              <i
                class="bi bi-arrow-90deg-left pe-4"
                style={{ fontSize: "1.2rem", cursor: "pointer" }}
                onClick={navigateBack}
              ></i>
            ) : null}
            {title}
          </h2>
        )}
        {rightButtonLabel && rightButtonHandler ? (
          <button
            className="btn btn-secondary fw-medium"
            style={{ fontSize: ".875rem" }}
            onClick={rightButtonHandler}
          >
            {rightButtonLabel}
          </button>
        ) : null}
      </div>

      {infiniteScroll && Object.keys(infiniteScroll).length > 0 ? (
        <InfiniteScroll
          className="h-100 d-flex gap-4 w-100 flex-column"
          loadMore={infiniteScroll.loadMore}
          hasMore={infiniteScroll.hasMore}
        >
          {children}
        </InfiniteScroll>
      ) : (
        children
      )}

      {buttonHandler && <FloatingButton onClick={buttonHandler} />}
    </div>
  );
}
